<template>
  <aside id="sidebar" class="sidebar croll">
    <ul class="sidebar-nav" id="sidebar-nav">
      <li class="nav-item">
        <router-link class="nav-link collapsed" @click.enter="Resize" to="/"
          :class="{ 'activesli': $route.name === 'home' }">
          <svg class="s-distance" style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24"><path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"></path></svg>
          <span>Inicio</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="rolAdmin || authDocente">
        <router-link class="nav-link collapsed" @click.enter="Resize" to="/cursos-asignados"
          :class="{ 'activesli': $route.name === 'cuas' }">
          <svg class="s-distance" style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" ><path d="m16 2.012 3 3L16.713 7.3l-3-3zM4 14v3h3l8.299-8.287-3-3zm0 6h16v2H4z"></path></svg>
          <span>Calificaciones</span>
        </router-link>
      </li>
      <!------------ MENU ESTUDIANTES --------->
      <li class="nav-item" v-if="authEstudiante">
        <router-link class="nav-link collapsed" @click.enter="Resize" to="/calificaciones"
          :class="{ 'activesli': $route.name === 'cali' }">
          <svg class="s-distance" style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" ><path d="m16 2.012 3 3L16.713 7.3l-3-3zM4 14v3h3l8.299-8.287-3-3zm0 6h16v2H4z"></path></svg>
          <span>Calificaciones</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="authEstudiante">
        <router-link class="nav-link collapsed" @click.enter="Resize" to="/my-course"
          :class="{ 'activesli': $route.name === 'myco'||$route.name === 'myho' }">
          <svg class="s-distance" style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" ><path d="M2 8v4.001h1V18H2v3h16l3 .001V21h1v-3h-1v-5.999h1V8L12 2 2 8zm4 10v-5.999h2V18H6zm5 0v-5.999h2V18h-2zm7 0h-2v-5.999h2V18zM14 8a2 2 0 1 1-4.001-.001A2 2 0 0 1 14 8z"></path></svg>
          <span>Aulas virtuales</span>
        </router-link>
      </li>
      <!------------ FIN ESTUDIANTES --------->
      <li class="nav-item" v-if="rolAdmin || authDocente">
        <router-link class="nav-link collapsed" @click.enter="Resize" to="/tutoria"
          :class="{ 'activesli': $route.name === 'tuto' }">
          <svg class="s-distance" style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" ><path d="M20.664 3.478 8 8v7l.748.267-1.127 2.254a1.999 1.999 0 0 0 1.156 2.792l4.084 1.361a2.015 2.015 0 0 0 2.421-1.003l1.303-2.606 4.079 1.457A1 1 0 0 0 22 18.581V4.419a1 1 0 0 0-1.336-.941zm-7.171 16.299L9.41 18.416l1.235-2.471 4.042 1.444-1.194 2.388zM4 15h2V8H4c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2z"></path></svg>
          <span class="position-relative">Tutoría
            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill" style="background: linear-gradient(80.84deg, #493AB7 0%, #925DFF 100%);">
              new
            </span>
          </span>
        </router-link>
      </li>
      <li class="nav-item" v-if="rolAdmin || authDocente">
        <router-link class="nav-link collapsed" @click.enter="Resize" to="/producto"
          :class="{ 'activesli': $route.name === 'pdt' }">
          <svg class="s-distance" style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" ><path d="m16 2.012 3 3L16.713 7.3l-3-3zM4 14v3h3l8.299-8.287-3-3zm0 6h16v2H4z"></path></svg>
          <span>ECA</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="rolAdmin || authDocente">
        <router-link class="nav-link collapsed" @click.enter="Resize" to="/proyecto"
          :class="{ 'activesli': $route.name === 'pyt' }">
          <svg class="s-distance" style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" ><path d="m16 2.012 3 3L16.713 7.3l-3-3zM4 14v3h3l8.299-8.287-3-3zm0 6h16v2H4z"></path></svg>
          <span>Proyectos</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="rolAdmin || authDocente || authVicerrector">
        <router-link class="nav-link collapsed" @click.enter="Resize" to="/drive"
          :class="{ 'activesli': $route.name === 'driv' }">
          <svg class="s-distance" style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M8 13h2v7H8zm3 2h2v7h-2zm3-2h2v7h-2z"></path><path d="M18.944 10.113C18.507 6.671 15.56 4.001 12 4.001c-2.756 0-5.15 1.611-6.243 4.15C3.609 8.793 2 10.82 2 13.001c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3 0-1.403 1.199-2.756 2.673-3.015l.581-.103.192-.559C8.149 7.274 9.895 6.001 12 6.001c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-1v2h1c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"></path></svg>
    
          <span>Planificaciones</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="rolAdmin || authDocente">
        <router-link class="nav-link collapsed" @click.enter="Resize" to="/courses"
          :class="{ 'activesli': $route.name === 'audo' ||$route.name === 'auhom' }">
          <svg class="s-distance" style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M21 10h-2V4h1V2H4v2h1v6H3a1 1 0 0 0-1 1v9h20v-9a1 1 0 0 0-1-1zm-7 8v-4h-4v4H7V4h10v14h-3z"></path><path d="M9 6h2v2H9zm4 0h2v2h-2zm-4 4h2v2H9zm4 0h2v2h-2z"></path></svg>
          <span class="position-relative">Aulas virtuales
            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill" style="background: linear-gradient(78.33deg, #493AB7 0%, #CF4B0A 100%);">
              new
            </span>
          </span>
        </router-link>
      </li>
      <hr v-if="rolAdmin" class="s-hr-color">
      <li class="nav-item" v-if="rolAdmin">
        <a class="nav-link collapsed" @click="openEstad" href="javascript:;"
          :class="{ 'activesli': $route.name === 'estno' }">  
          <svg class="s-distance" style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M6 21H3a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1zm7 0h-3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1zm7 0h-3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1z"></path></svg>
          <span>Estadistica notas</span>
        </a>
      </li>
      <hr v-if="authDocente && !rolAdmin" class="s-hr-color">
      <li class="nav-item" v-if="authDocente && !rolAdmin">
        <router-link class="nav-link collapsed" @click.enter="Resize" to="/comunn"
          :class="{ 'activesli': $route.name === 'conn' }">
          <svg class="s-distance" style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" ><path d="M12 2C6.486 2 2 5.589 2 10c0 2.908 1.897 5.516 5 6.934V22l5.34-4.004C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm-2.5 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"></path></svg>
          
          <span class="position-relative">Comunicaciones
          </span>
        </router-link>
      </li>
      <li class="nav-item" v-if="rolAdmin || authDocente || authVicerrector">
        <router-link class="nav-link collapsed" @click.enter="Resize" to="/horarios-clases"
          :class="{ 'activesli': $route.name === 'hocl' }">
          <svg class="s-distance" style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M5.559 8.855c.166 1.183.789 3.207 3.087 4.079C11 13.829 11 14.534 11 15v.163c-1.44.434-2.5 1.757-2.5 3.337 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337V15c0-.466 0-1.171 2.354-2.065 2.298-.872 2.921-2.896 3.087-4.079C19.912 8.441 21 7.102 21 5.5 21 3.57 19.43 2 17.5 2S14 3.57 14 5.5c0 1.552 1.022 2.855 2.424 3.313-.146.735-.565 1.791-1.778 2.252-1.192.452-2.053.953-2.646 1.536-.593-.583-1.453-1.084-2.646-1.536-1.213-.461-1.633-1.517-1.778-2.252C8.978 8.355 10 7.052 10 5.5 10 3.57 8.43 2 6.5 2S3 3.57 3 5.5c0 1.602 1.088 2.941 2.559 3.355zM17.5 4c.827 0 1.5.673 1.5 1.5S18.327 7 17.5 7 16 6.327 16 5.5 16.673 4 17.5 4zm-4 14.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5.673-1.5 1.5-1.5 1.5.673 1.5 1.5zM6.5 4C7.327 4 8 4.673 8 5.5S7.327 7 6.5 7 5 6.327 5 5.5 5.673 4 6.5 4z"></path></svg>
          <span class="position-relative">Horarios
            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
              new
            </span>
          </span>
        </router-link>
      </li>
      <li class="nav-item" v-if="rolAdmin || authSecretario">
        <router-link class="nav-link collapsed" @click.enter="Resize" to="/reportes"
          :class="{ 'activesli': $route.name === 'reho' }">
          <svg class="s-distance" style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M19 7h-1V2H6v5H5c-1.654 0-3 1.346-3 3v7c0 1.103.897 2 2 2h2v3h12v-3h2c1.103 0 2-.897 2-2v-7c0-1.654-1.346-3-3-3zM8 4h8v3H8V4zm8 16H8v-4h8v4zm4-3h-2v-3H6v3H4v-7c0-.551.449-1 1-1h14c.552 0 1 .449 1 1v7z"></path><path d="M14 10h4v2h-4z"></path></svg>
          
          <span>Reportes</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="rolAdmin">
        <a class="nav-link collapsed" @click="openSeguimiento" href="javascript:;">
          <svg class="s-distance" style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M14.82 4.26a10.14 10.14 0 0 0-.53 1.1 14.66 14.66 0 0 0-4.58 0 10.14 10.14 0 0 0-.53-1.1 16 16 0 0 0-4.13 1.3 17.33 17.33 0 0 0-3 11.59 16.6 16.6 0 0 0 5.07 2.59A12.89 12.89 0 0 0 8.23 18a9.65 9.65 0 0 1-1.71-.83 3.39 3.39 0 0 0 .42-.33 11.66 11.66 0 0 0 10.12 0q.21.18.42.33a10.84 10.84 0 0 1-1.71.84 12.41 12.41 0 0 0 1.08 1.78 16.44 16.44 0 0 0 5.06-2.59 17.22 17.22 0 0 0-3-11.59 16.09 16.09 0 0 0-4.09-1.35zM8.68 14.81a1.94 1.94 0 0 1-1.8-2 1.93 1.93 0 0 1 1.8-2 1.93 1.93 0 0 1 1.8 2 1.93 1.93 0 0 1-1.8 2zm6.64 0a1.94 1.94 0 0 1-1.8-2 1.93 1.93 0 0 1 1.8-2 1.92 1.92 0 0 1 1.8 2 1.92 1.92 0 0 1-1.8 2z"></path></svg>
          <span>Seguimiento</span>
        </a>
      </li>
      <hr v-if="rolAdmin" class="s-hr-color">
      
      <li class="nav-item" v-if="rolAdmin">
        <router-link class="nav-link collapsed" @click.enter="Resize" to="/admin-site"
          :class="{ 'activesli': $route.name === 'admin' }">
          <svg class="s-distance" style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" ><path d="m2.344 15.271 2 3.46a1 1 0 0 0 1.366.365l1.396-.806c.58.457 1.221.832 1.895 1.112V21a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1.598a8.094 8.094 0 0 0 1.895-1.112l1.396.806c.477.275 1.091.11 1.366-.365l2-3.46a1.004 1.004 0 0 0-.365-1.366l-1.372-.793a7.683 7.683 0 0 0-.002-2.224l1.372-.793c.476-.275.641-.89.365-1.366l-2-3.46a1 1 0 0 0-1.366-.365l-1.396.806A8.034 8.034 0 0 0 15 4.598V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1.598A8.094 8.094 0 0 0 7.105 5.71L5.71 4.904a.999.999 0 0 0-1.366.365l-2 3.46a1.004 1.004 0 0 0 .365 1.366l1.372.793a7.683 7.683 0 0 0 0 2.224l-1.372.793c-.476.275-.641.89-.365 1.366zM12 8c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z"></path></svg>
          <span>Administrar sitio</span>
        </router-link>
      </li>
    </ul>
  </aside>
  <section v-if="isSeguimiento">
    <Suspense>
      <template #default>
        <SeguimientoView @closed="isSeguimiento = false" />
      </template>
      <template #fallback>
        <ProgressBar />
      </template>
    </Suspense>
  </section>
  <section v-if="isEstadis">
    <Suspense>
      <template #default>
        <HomeEstadis @closed="isEstadis = false" />
      </template>
      <template #fallback>
        <ProgressBar />
      </template>
    </Suspense>
  </section>
</template>
<style>
.s-distance {
  margin-right: 10px;
}
</style>
<script>
import { defineAsyncComponent } from 'vue'
import ProgressBar from '@/shared/ProgressBar.vue';
export default {
  name: 'Header',
  data() {
    return {
      isMobile: false,
      nombre: false,
      isSetting: false,
      isSeguimiento: false,
      isEstadis : false,
    }
  },
  components: {
    ProgressBar,
    SeguimientoView: defineAsyncComponent(() =>
      import('../modules/setting/logs/SeguimientoView.vue')
    ),
    HomeEstadis: defineAsyncComponent(() =>
      import('../modules/estadistica/HomeEstadis.vue')
    ),
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    rolAdmin() {
      return this.$store.getters.user.roles.includes('Admin');
    },
    authDocente() {
      return this.$store.getters.user.roles.includes('Docente');
    },
    authEstudiante() {
      return this.$store.getters.user.roles.includes('Estudiante');
    },
    authSecretario() {
      return this.$store.getters.user.roles.includes('Secretario');
    },
    authVicerrector() {
      return this.$store.getters.user.roles.includes('Vicerrector');
    },
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
    this.inforUsers()
  },
  methods: {
    openSeguimiento: function () {
      this.Resize();
      this.isSeguimiento = true;
    },
    openEstad: function () {
      this.Resize();
      this.isEstadis = true;
    },
    Resize() {
      let Mobile = window.innerWidth < 1200
      if (Mobile) {
        this.toggleBodyClass()
      }
    },
    toggleBodyClass() {
      const el = document.body;
      el.classList.remove('toggle-sidebar');
    },
    onResize() {
      this.isMobile = window.innerWidth < 1100
    },
    inforUsers() {
      const info = JSON.parse(localStorage.getItem('Xf'));
      if (info) this.nombre = info.nombre;
    },
  },
}
</script>